import { RefObject, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useAppDispatch } from '@store';
import { useScroll } from '@ui/src';
import { useLazyGetCustomerLocksQuery } from '../../store/services/individual';
import { clearLocks, setLocksTakeCount } from '../../store/slices/security';
import { Lock } from '../../types';
import { clearActiveLock } from '../../store/slices/general-info';

const useLocksList = ({
  scrollRef,
  activeLock,
  locks,
}: {
  scrollRef: RefObject<HTMLDivElement | null>;
  activeLock?: Lock;
  locks?: Lock[];
}) => {
  const [getList, { isFetching, isLoading }] = useLazyGetCustomerLocksQuery();

  const dispatch = useAppDispatch();
  const { search } = useLocation();

  useScroll({
    element: scrollRef,
    requestInProgress: isFetching,
  });

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      const { offsetHeight } = scrollRef.current;

      if (offsetHeight) {
        const take = offsetHeight / 58;

        dispatch(setLocksTakeCount(Math.ceil(take + 3)));
      }
    }
  }, [scrollRef]);

  useEffect(() => {
    if (search && activeLock && locks !== undefined) {
      const parsed = queryString.parse(search);

      if (
        parsed &&
        parsed.locked &&
        parsed.locked === 'true' &&
        !locks?.length
      ) {
        dispatch(clearActiveLock());
      }
    }
  }, [search, locks, activeLock]);

  useEffect(
    () => () => {
      dispatch(clearLocks());
    },
    [],
  );

  return {
    getList,
    isFetching,
    isLoading,
  };
};

export default useLocksList;
